<template>
  <div>
    <div class="top2 EC_width display_flex" style="width: 1200px; align-items: center; justify-content: space-between;">
      <div class="t2box1 display_flex">
        <img :src="left.resUrl" class="t2img" alt="">
        <div class="t2span display_column_between">
          <div class="t2st1">{{ left.title }}</div>
          <div class="t2st2">{{ left.detail }}</div>
          <div class="t2st3" @click="tourl(1)">{{ left.title }}</div>
        </div>
      </div>
      <div class="t2box2 display_flex">
        <img :src="right.resUrl" class="t2img" alt="">
        <div class="t2span display_column_between">
          <div class="t2st1" style="color: #0B8586;">{{ right.title }}</div>
          <div class="t2st2">{{ right.detail }}</div>
          <div class="t2st3" @click="tourl(2)">{{ right.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      left: {},
      right: {}
    }
  },

  created () {
    this.getleft()
    this.getright()
  },

  methods: {
    tourl (num) {
      if (num == 1) {
        // this.$router.push('/user/upload')
         this.$alert('案例收集已关闭', '提示', {
        confirmButtonText: '确定',
        callback: action => {

        }
        });
      } else {
        // this.$alert('案例收集中...', '提示', {
        // confirmButtonText: '确定',
        // callback: action => {

        // }
        // });
        this.$router.push('/refinedSift')
      }
    },
    getleft () {
      this.httphelper
        .post('/WebSiteApi/GetHCRotation', {
          type: 2,
          uselocation: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.left = res.data.data[0]
          }
          // console.log(res, 'zuo')
        })
    },

    getright () {
      this.httphelper
        .post('/WebSiteApi/GetHCRotation', {
          type: 3,
          uselocation: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.right = res.data.data[0]
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.top2 {
  // height: 340px;
  background: #f7f7f7;
  padding: 45px 0;

  .t2box1 {
    width: 585px;
    height: 250px;
    background: #e9ddd2;
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.03);
    border-radius: 8px;
  }

  .t2box2 {
    width: 585px;
    height: 250px;
    background: #d2e9e8;
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    // margin-left: 30px;
  }

  .t2img {
    // width: 400px;
    // height: 250px;
    width: 400px;
    height:250px;
    object-fit: cover; /* or 'contain', 'fill', 'scale-down', 'none' */
  }

  .t2span {
    padding: 33px 25px;
    flex: 1;

    .t2st1 {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ae0002;
      line-height: 54px;
    }

    .t2st2 {
      height: 96px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 24px;
    }

    .t2st3 {
      width: 100px;
      height: 34px;
      background: #ffffff;
      border-radius: 17px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #404040;
      line-height: 34px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
